<template>
<div class= 'wrp' >
    <div class= 'content-top' >
      <div>{{name}}数字化税务管理平台</div>
    </div>
    <div class= 'text-title' >提示条款</div>
    <div class= 'common-text' >
      特别提示：
      <strong>
      用户应认真阅读本《服务许可协议》（下称《协议》）中各条款，特别是免除或者限制{{companyName}}（下称"{{companyShortName}}"）责任的条款及限制用户权利的条款。请您在仔细阅读并充分理解的前提下自愿决定是否接受本《协议》条款（未成年人应在法定监护人陪同下审阅）。除非您接受本《协议》条款，否则无权下载、安装或使用{{companyShortName}}客户端软件（下称"软件"），也无权使用其相关云端服务（下称“服务”）。如果您选择使用本"软件"及"服务"，将视为您接受本《协议》各项条款的约束。
      本《协议》是用户与{{companyShortName}}之间关于用户下载、安装、使用、复制"{{companyShortName}}客户端"软件（以下简称"软件"）所订立的协议。本《协议》描述{{companyShortName}}与用户之间关于"软件"许可使用及相关方面的权利义务。"用户"或"您"是指通过{{companyShortName}}提供的获取软件授权的途径获得软件授权许可和/或软件产品的个人或单一实体。
      </strong >
    </div>
    <div>
      <div class= 'text-title' >1 、权利声明</div>
      <div class= 'common-text' >
        <span>
        本"软件"及“服务”由{{companyName}}开发。本"软件"及“服务”的计算机软件著作权以及与本"软件"及“服务”相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、或电子文档等均为{{companyShortName}}独立所有，受中国著作权法和国际著作权公约以及其他知识产权法律法规的保护。
        </span>
      </div>
    </div>
    <div>
      <div class= 'text-title' >2 、用户使用许可授权范围</div>
      <div class= 'common-text' >
        <span class= 'common-title' >2.1</span>
        <span>
          <strong>用户可以在单一计算机（下称"计算机"）或手机上下载、安装、使用、显示、运行本"软件"。</strong>
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >2.2</span>
        <span>
          <strong
            >用户可以通过开通授权的账号和密码登录{{name}}数字化税务管理平台 ，使用授权的电子发票开具（存储、交付）、发票修复、红字发票等相关服务。</strong
          >
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >2.3</span>
        <span>
          <strong
            >
            保留权利：本《协议》未明示授权的其他一切权利仍归{{companyShortName}}所有，用户使用其他权利时须另外取得{{companyShortName}}的书面同意。</strong
          >
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >2.4</span>
        <span>
          除本《协议》有明确规定外，本《协议》并未对利用本"软件"及“服务”访问{{companyShortName}}的其他服务规定相关的服务条款，对于这些服务可能有单独的服务条款加以规范，请用户在使用有关服务时另行了解与确认。如用户使用该服务，视为对相关服务条款的接受。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >2.5</span>
        <span>
          用户必须依本平台、平台战略合作伙伴（包括本平台合作的金融机构以及征信机构，下同）要求提供真实、最新、有效及完整的资料，并且授予本平台、平台战略合作伙伴基于提供网站服务的目的对其提供的资料及数据信息拥有永久的、免费的使用权利，授予本平台将以上信息分享给拟向用户提供服务的金融机构及征信机构。
        </span>
      </div>
      <div class= 'text-title' >3、 用户使用须知</div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.1 软件功能及服务</span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.1.1 销项管理服务</span>
        <span>
        （1）用户在此不可撤销地同意并授权{{companyShortName}}以及联合合作单位通过使用用户所授权的税控设备提供云端开票、单据管理、发票归集、基础信息管理、用户权限管理等相关服务；
用户在此不可撤销地同意并授权{{companyShortName}}使用其企业名称、税号、企业公章模板为其申请电子发票专用章CA证书，此授权有效期与用户合法注册的其他账号有效期一致。用户在此郑重承诺并保证其所提交的所有申请信息和材料均真实、有效、完整，否则将承担相应法律责任。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.1.2 “发票小助手” 服务</span>
        <span>
          <strong
            >用户在此不可撤销地同意并授权{{companyShortName}}通过“发票小助手”进行以下操作：读取税盘信息；打印电子发票开票二维码；生成并显示或打印纸质发票开具上传信息的二维码；向税务局申请开通电票服务并使用{{name}}完成电票开具；直接调起打印机驱动进行纸票打印；记录和使用用户数字证书密码和税控盘口令；修改、替换和升级软件等其他相关操作。</strong
          >
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.1.3 发票数据抽取和备份服务</span>
        <div>
        （1）用户在此不可撤销地同意并授权{{companyShortName}}对用户的发票数据进行必要的采集、加工、存储、上传、下载、分析以提供优质高效的增值税发票服务。{{companyShortName}}理解并认可用户的发票数据为用户自身的业务数据，用户对该数据拥有完全的所有权。
        </div>
        <div>
        （2）在客户具有特定需求并对{{companyShortName}}明确授权后，{{companyShortName}}有权将发票数据及其分析结果提供给客户指定的第三方服务商以满足用户的特定需求。
        </div>
        <div>
        （3）除本条第（2）款情形外，未经用户明确授权或同意，{{companyShortName}}不会将用户的发票数据披露给其他第三方，或者用于其他目的，但以下两种情形除外：
            第一、在国家有关机关依法查询或调阅用户业务数据时，按照相关法律法规或政策文件要求，{{companyShortName}}有义务配合并向行政、司法或其他第三方披露的；
            第二、用户和{{companyShortName}}另行协商一致的。
        </div>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.2</span>
        <span>
          <strong>本"软件"及“服务”不含有任何旨在破坏用户计算机数据和获取用户隐私信息的恶意代码，不含有任何跟踪、监视用户计算机和或操作行为的功能代码，不会监控用户网上、网下的行为或泄漏用户隐私。</strong>
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.3</span>
        <span>
          用户在遵守法律及本《协议》的前提下可依本《协议》使用本"软件"及“服务”。用户无权实施包括但不限于下列行为：
        </span>
      </div>
      <div class= 'common-text' >
        <span>
        <div>（1）不得删除本"软件"及其他副本上所有关于版权的信息、内容；</div>
        <div>（2） 不得对本"软件"进行反向工程、反向汇编、反向编译等；</div>
        <div>（3） 对于本"软件"相关信息等，未经{{companyShortName}}书面同意，用户不得擅自实施包括但不限于下列行为：使用、复制、修改、链接、转载、汇编、发表、出版，擅自借助"软件"发展与之有关的衍生产品、作品、服务等。</div>
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.4 </span>
        <span>
        使用本"软件"及“服务”必须遵守国家有关法律和政策，并遵守本《协议》，对于用户违法或违反本《协议》的使用而引起的一切责任，由用户负全部责任，一概与{{companyShortName}}及合作单位无关，导致{{companyShortName}}及合作单位损失的，{{companyShortName}}及合作单位有权要求用户赔偿，并有权立即停止向其提供服务，保留相关记录，保留配合司法机关追究法律责任的权利。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.5</span>
        <span>
        本"软件"及“服务”同大多数互联网软件一样，可能受到各种安全问题的侵扰；用户利用本"软件"下载安装的其它软件中可能含有"特洛伊木马"等病毒，威胁到用户的计算机信息和数据的安全，继而影响本"软件"的正常使用等等。因此，{{companyShortName}}提醒用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.6</span>
        <span>
          非{{companyShortName}}自主开发或授权第三方开发并正式发布的其它任何由本"软件"衍生的软件均属非法，下载、安装、使用此类软件，将可能导致不可预知的风险，建议用户不要轻易下载、安装、使用，由此产生的一切法律责任与纠纷一概与{{companyShortName}}无关。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.7</span>
        <span>
          {{companyShortName}}保留在任何时候根据适用法律、法规或政府要求的需要而披露任何信息，或由{{companyShortName}}自主决定全部或部分地编辑、拒绝张贴或删除任何信息或资料的权利。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.8</span>
        <span>
        隐私权政策：为了给用户提供更好的服务，当用户使用或者启动“软件”时，服务器会自动记录一些信息，包括但不限于URL、IP地址、浏览器的类型和使用的语言以及访问日期和时间等。除非取得用户同意、或者政府部门根据法律法规提出要求、或者用户违反了本《协议》的约定、或者维护{{companyShortName}}合法权利等情形，{{companyShortName}}将不会泄露用户的任何使用信息。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.9</span>
        <span>
        "软件"的替换、修改和升级：{{companyShortName}}保留在任何时候为用户提供本"软件"替换、修改、升级版本的权利。同时，用户在此同意，为提高用户体验，{{companyShortName}}有权将其他相关产品绑定在本“软件”上供用户进行下载和安装。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >3.10</span>
        <span>
        本"软件"及“服务”可能使用的第三方软件或技术，是受到合法授权的。因第三方软件或技术引发的任何纠纷，由该第三方负责解决，{{companyShortName}}不承担任何责任。{{companyShortName}}不对第三方软件或技术提供客服支持，若您需要获取支持，请与该软件或技术提供商联系。。
        </span>
      </div>
    </div>
    <div>
      <div class= 'text-title' >4、 法律责任与免责</div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.1 </span>
        <span>
        {{companyShortName}}特别提醒用户注意，{{companyShortName}}为了保障公司业务发展和调整的自主权，{{companyShortName}}拥有随时自行修改或中断软件授权而不需通知用户的权利，如有必要，此类修改或中断会以通告形式公布于{{companyShortName}}网站页面上，请用户及时关注网站消息。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.2</span>
        <span>
        用户不当使用本"软件"及“服务”包含的{{companyShortName}}进项管理服务、销项管理服务、{{name}}盒及助手、数据抽取和备份服务而导致的任何违反约定、侵犯他人权利、侵犯{{companyShortName}}的版权或知识产权或造成自身或他人的损失（包括因下载而感染电脑病毒），均由用户自行负责，{{companyShortName}}概不对造成的损失负责，亦不对外承担任何法律责任。若用户造成{{companyShortName}}损失的，应对{{companyShortName}}因此发生的所有直接和间接损失承担赔偿责任。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.3</span>
        <span>
        用户违反本《协议》或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的诉讼费用和律师费用，用户同意赔偿{{companyShortName}}与合作公司、关联公司的所有损失，并使之免受损害。对此，{{companyShortName}}有权视用户的行为性质，采取包括但不限于中断使用许可、停止提供服务、限制使用、法律追究等措施。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.4</span>
        <span>
        使用本"软件"涉及到互联网服务，可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何网络、技术、通信线路等原因造成的服务中断或不能满足用户要求的风险，用户已经知晓并自行承担以上风险，{{companyShortName}}对此不承担任何责任。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.5</span>
        <span>
        用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种非因{{companyShortName}}本身的原因而遭受的经济损失，{{companyShortName}}不承担任何责任。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >4.6</span>
        <span>
        因技术故障等不可抗事件力影响到服务的正常运行的，{{companyShortName}}承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的经济损失，{{companyShortName}}不承担任何责任。
        </span>
      </div>
      <div>
      <div class= 'text-title' >5 、其他条款
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >5.1</span>
        <span>
        本《协议》所定的任何条款的部分或全部无效，不影响其它条款的效力。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >5.2</span>
        <span>
        本《协议》的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和{{companyShortName}}之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交{{companyShortName}}所在地法院管辖。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >5.3</span>
        <span>
        本《协议》的一切解释权与修改权归{{companyShortName}}所有。
        </span>
      </div>
      <div class= 'common-text' >
        <span class= 'common-title' >5.4</span>
        <span>
        本《协议》自用户选择下载、安装或使用本"软件"之日生效。
        </span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { platformConfig } from '@assets/config'
export default {
  data () {
    return {
      name: platformConfig.getName(),
      companyName: platformConfig.getCompanyName(),
      companyShortName: platformConfig.getCompanyShortName()
    }
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
